import StrainResults from "./StrainResults";

export default StrainResults;
